import { render, staticRenderFns } from "./storeCouponsRecord.vue?vue&type=template&id=8f82f198&"
import script from "./storeCouponsRecord.vue?vue&type=script&lang=js&"
export * from "./storeCouponsRecord.vue?vue&type=script&lang=js&"
import style0 from "./storeCouponsRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports